var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25002 5.87533L8.58335 6.54199C8.43058 6.69477 8.25349 6.77116 8.0521 6.77116C7.85071 6.77116 7.67363 6.69477 7.52085 6.54199C7.36808 6.38921 7.29169 6.21213 7.29169 6.01074C7.29169 5.80935 7.36808 5.63227 7.52085 5.47949L9.47919 3.52116C9.63196 3.36838 9.80558 3.29199 10 3.29199C10.1945 3.29199 10.3681 3.36838 10.5209 3.52116L12.4792 5.47949C12.632 5.63227 12.7084 5.80588 12.7084 6.00033C12.7084 6.19477 12.632 6.36838 12.4792 6.52116C12.3264 6.67394 12.1493 6.75033 11.9479 6.75033C11.7465 6.75033 11.5695 6.67394 11.4167 6.52116L10.75 5.87533V16.2503C10.75 16.4587 10.6771 16.6357 10.5313 16.7816C10.3854 16.9274 10.2084 17.0003 10 17.0003C9.79169 17.0003 9.6146 16.9274 9.46877 16.7816C9.32294 16.6357 9.25002 16.4587 9.25002 16.2503V5.87533Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpArrow);
export default __webpack_public_path__ + "static/media/sortUpArrow.90415d78afc4ae4b5bd856d5e023f879.svg";
export { ForwardRef as ReactComponent };